import {Log, UserManager, WebStorageStateStore, User } from "oidc-client";

// Log.logger = console;
// Log.level = Log.DEBUG;
Log.level = Log.NONE; // Use Log.ERROR if you want to keep some output
export default class AuthService {
  userManager: UserManager;
  private cachedUser: User | null = null;
  private isPerformingAuthOperation = false; // Flag to prevent concurrent auth operations

  constructor() {
    const settings = {

        authority: process.env.REACT_APP_AUTHORITY,
        client_id: process.env.REACT_APP_CLIENT_ID,
        redirect_uri: process.env.REACT_APP_REDIRECT_URI,
        response_type: process.env.REACT_APP_RESPONSE_TYPE,
        scope: "openid profile chatApi email address roles id identity_api", // Added identity_api scope
        post_logout_redirect_uri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI,
        automaticSilentRenew: false,
        loadUserInfo: true,
        userStore: new WebStorageStateStore({ store: window.localStorage }),

    //   authority: process.env.REACT_APP_AUTHORITY,
    //   client_id: process.env.REACT_APP_CLIENT_ID,
    //   redirect_uri: process.env.REACT_APP_REDIRECT_URI,
    //   response_type: process.env.REACT_APP_RESPONSE_TYPE,
    //   // ## NEXT UPDATE TRY THIS ##
    //   // client_secret: process.env.REACT_APP_CLIENT_SECRET, # SAFER WITHOUT THIS
    //   // ###
    //   scope: "openid profile chatApi email address roles id", // Keep original scopes
    //   post_logout_redirect_uri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI,
    //   automaticSilentRenew: false,
    //   // silent_redirect_uri: process.env.REACT_APP_SILENT_REDIRECT_URI,
    //   loadUserInfo: true,
    //   // ### NEXT UPDATe TRY THIS ###
    //   accessTokenExpiringNotificationTime: 60,
    //   includeIdTokenInSilentRenew: true,
    // // ######
    //   userStore: new WebStorageStateStore({ store: window.localStorage }),
    };

    this.userManager = new UserManager(settings);

    // Event listeners - keep as is
    this.userManager.events.addUserLoaded((user) => {
      this.cachedUser = user;
      this.isPerformingAuthOperation = false; // Reset flag when user is loaded
    });
    this.userManager.events.addUserSignedOut(() => {
      this.cachedUser = null;
      this.isPerformingAuthOperation = false; // Reset flag when user is signed out
    });
  }

  async getUser() {
    // If we have a cached non-expired user, return it immediately
    if (this.cachedUser && !this.cachedUser.expired) {
      return this.cachedUser;
    }

    try {
      const user = await this.userManager.getUser();
      if (user && !user.expired) {
        this.cachedUser = user;
        return user;
      }
      return null;
    } catch (e) {
      console.error("AuthService.getUser error", e);
      // Don't automatically redirect - this could cause logout on second click
      return null;
    }
  }

  async getUserData() {
    const user = await this.getUser();
    if (user?.profile?.email) return { email: user.profile.email };
    return null;
  }

  login() {
    // Prevent concurrent login operations
    if (this.isPerformingAuthOperation) {
      console.log("Auth operation in progress, skipping login request");
      return Promise.resolve();
    }
    
    this.isPerformingAuthOperation = true;
   
    ///tHis/// 
    // localStorage.clear();
    // sessionStorage.clear();
    ///FOR THIS ///
    Object.keys(localStorage).forEach((key) => {
  if (!key.startsWith("oidc.")) localStorage.removeItem(key);
});
    
    return this.userManager.signinRedirect()
      .catch(error => {
        console.error("Login error:", error);
        this.isPerformingAuthOperation = false; // Reset flag on error
      });
  }

  logout() {
    // Prevent concurrent logout operations
    if (this.isPerformingAuthOperation) {
      console.log("Auth operation in progress, skipping logout request");
      return Promise.resolve();
    }
    
    this.isPerformingAuthOperation = true;
    this.cachedUser = null;
    
    return this.userManager.signoutRedirect()
      .catch(error => {
        console.error("Logout error:", error);
        this.isPerformingAuthOperation = false; // Reset flag on error
      });
  }

  async getAccessToken() {
  try {
    const user = await this.getUser();

    if (!user || !user.access_token || user.expired) {
      console.warn("User not authenticated or token expired. Redirecting to login.");
      this.login(); // Force interactive login
      return null;
    }

    return user.access_token;
  } catch (error) {
    console.error("getAccessToken error:", error);
    return null;
  }
}

  /**
   * Refresh user claims - useful after subscription changes
   * This performs a silent sign-in to get fresh claims from the server
   */
  async refreshUserClaims() {
    if (this.isPerformingAuthOperation) {
      console.log("Auth operation in progress, skipping claim refresh");
      return false;
    }

    this.isPerformingAuthOperation = true;
    
    try {
      console.log("Refreshing user claims via silent sign-in...");
      const renewedUser = await this.userManager.signinSilent();
      this.cachedUser = renewedUser;
      this.isPerformingAuthOperation = false;
      console.log("User claims refreshed successfully");
      return true;
    } catch (error) {
      console.error("Failed to refresh user claims:", error);
      this.isPerformingAuthOperation = false;
      return false;
    }
  }

  // async getAccessToken() {
  //   try {
  //     const user = await this.getUser();

  //     // If no user or no token, try a silent refresh
  //     if (!user || !user.access_token) {
  //       // Prevent multiple concurrent silent sign-in attempts
  //       if (this.isPerformingAuthOperation) {
  //         console.log("Auth operation in progress, skipping token refresh");
  //         return null;
  //       }
        
  //       this.isPerformingAuthOperation = true;
        
  //       try {
  //         // Check if token might be expired
  //         const renewedUser = await this.userManager.signinSilent();
  //         this.cachedUser = renewedUser;
  //         this.isPerformingAuthOperation = false;
  //         return renewedUser.access_token;
  //       } catch (error) {
  //         console.error("Silent sign-in failed:", error);
  //         this.isPerformingAuthOperation = false;
          
  //         // Only redirect if we're not already in an auth operation
  //         if (!this.isPerformingAuthOperation) {
  //           this.login();
  //         }
  //         return null;
  //       }
  //     }
      
  //     // Check token expiration
  //     if (user.expired) {
  //       console.log("Token has expired, attempting silent renew");
        
  //       if (this.isPerformingAuthOperation) {
  //         return null; // Avoid concurrent operations
  //       }
        
  //       this.isPerformingAuthOperation = true;
  //       try {
  //         const renewedUser = await this.userManager.signinSilent();
  //         this.cachedUser = renewedUser;
  //         this.isPerformingAuthOperation = false;
  //         return renewedUser.access_token;
  //       } catch (error) {
  //         console.error("Token renewal failed:", error);
  //         this.isPerformingAuthOperation = false;
          
  //         if (!this.isPerformingAuthOperation) {
  //           this.login(); // Redirect to login if renewal fails
  //         }
  //         return null;
  //       }
  //     }

  //     return user.access_token;
  //   } catch (error) {
  //     console.error("getAccessToken error:", error);
  //     this.isPerformingAuthOperation = false;
  //     return null;
  //   }
  // }
}